import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import type { IResponseConversation } from 'entities/Conversation/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'

export const useEventConversationReassigned = (store: ConversationMenuStore) => {
  const { websocket, conversationStore, inboxesStore } = useEntitiesContext()
  const handle = (data: IResponseConversation) => {
    const lastReassignLog = data.reassign_logs?.length
      ? data.reassign_logs[data.reassign_logs.length - 1]
      : null
    const currentUser = lastReassignLog?.current_user

    const isUnassigned = currentUser === 0
    const isSkip = currentUser === null || currentUser === undefined
    const unreadCount = data.unread_count

    if (isSkip) return

    if (
      (inboxesStore.localInboxes.hasFilterUnassigned && !isUnassigned) ||
      (inboxesStore.localInboxes.hasFilterAssigned && isUnassigned)
    ) {
      conversationStore.decreaseItemsTotalCount()
      conversationStore.deleteItem(data.id)
      store.config?.setConversationFocusItem?.(data.id)
    }
    if (
      (inboxesStore.localInboxes.hasFilterUnassigned && isUnassigned) ||
      (inboxesStore.localInboxes.hasFilterAssigned && !isUnassigned)
    ) {
      conversationStore.increaseItemsTotalCount()
    }

    if (!unreadCount) return

    if (isUnassigned) {
      store.quickFiltersMenuStore.handleQuickFilterCountByKey({
        key: 'unassigned',
        isIncrease: true,
        increaseCount: unreadCount,
      })
      store.quickFiltersMenuStore.handleQuickFilterCountByKey({
        key: 'assigned',
        isIncrease: false,
        decreaseCount: unreadCount,
      })
    } else {
      store.quickFiltersMenuStore.handleQuickFilterCountByKey({
        key: 'unassigned',
        isIncrease: false,
        decreaseCount: unreadCount,
      })
      store.quickFiltersMenuStore.handleQuickFilterCountByKey({
        key: 'assigned',
        isIncrease: true,
        increaseCount: unreadCount,
      })
    }
  }

  useEffect(() => websocket.on(WebsocketEvent.ConversationReassigned, handle), [])
}
